import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/testimonials/caroline.jpg")